// Shared Chart.js styling for the dashboard widgets.
export const GRID_COLOUR = '#F1F1F1';

export const AXIS_TICKS = {
  color: '#6B7280',
  font: { size: 11 },
};

export const TOOLTIP = {
  backgroundColor: '#111827',
  padding: 10,
  cornerRadius: 6,
  titleFont: { size: 12 },
  bodyFont: { size: 12 },
};
